module.exports = __webpack_public_path__ + "img/icon04.4eddec81.svg";